import { PersonalTask } from '../../api/personal-tasks';
import { RootState } from '../index';

export const selectPersonalTask =
  (id: number) =>
  ({ personalTasks }: RootState): PersonalTask | undefined =>
    personalTasks.data.find((d) => d.personalTaskId === id);

export const selectPersonalTasks = (state: RootState) => state.personalTasks;
